import {
  Button,
  Card,
  Icon,
  Loading,
  message,
  Modal,
  SEO,
  Table,
  Title,
} from 'components/common'
import { Popconfirm } from 'antd-v5'
import React, { useState } from 'react'
import BookingsCalendar from 'components/bookings/calendar'
import ObserverForm from 'components/bookings/form/ObserverForm'
import CalendarSettingsTable from 'components/calendar/calendarSettingsTable'
import { useCalendarEvents } from 'lib/hooks/calendar'
import { useObserver } from 'lib/hooks/observer'

export const Head = () => <SEO title="予約リスト設定" />

// カレンダー設定ページ
const CalendarSettings = () => {
  // ページで持ってるstate
  const [isPreview, setIsPreview] = useState<boolean>(false)
  const [isCreateObserverForm, setIsCreateObserverForm] =
    useState<boolean>(false)
  const [isUpdateObserverForm, setIsUpdateObserverForm] =
    useState<boolean>(false)
  const [observerInfoById, setObserverInfoById] = useState({
    id: '',
    username: '',
    email: '',
    password: 'Sample@1234',
  })

  // GraphQL
  const {
    data: observerData,
    loading: observerLoading,
    observerDelete,
  } = useObserver()

  const { events, eventsRefetch } = useCalendarEvents()

  // オブザーバー一覧テーブルに渡すカラム
  const observerColumns = [
    {
      title: 'オブザーバー名',
      dataIndex: 'observer',
      key: 'observer',
    },
    {
      title: 'メールアドレス',
      dataIndex: 'email',
      key: 'email',
    },
    {
      title: '',
      dataIndex: 'actions',
      key: 'actions',
    },
  ]

  // 取得したオブザーバー一覧を参照して、Tableに渡すための配列を作成
  const observerList = observerData?.observers.map((observer) => {
    return {
      key: observer.auth0UserId,
      observer: observer.name,
      email: observer.email,
      actions: (
        <>
          <div className="flex gap-4">
            <Button
              onClick={() => {
                setObserverInfoById({
                  id: observer.auth0UserId,
                  username: observer.name,
                  email: observer.email,
                  password: 'Sample@1234',
                })
                setIsUpdateObserverForm(true)
              }}
              icon={<Icon.EditOutlined />}
            />
            <Popconfirm
              title="オブザーバー削除"
              description="この操作は取り消すことができません。削除しますか？"
              okText="はい"
              cancelText="いいえ"
              onConfirm={() => observerDelete(observer.auth0UserId)}
              onCancel={() => message.error('操作を取り消しました。')}
            >
              <Button danger icon={<Icon.DeleteFilled />} />
            </Popconfirm>
          </div>
        </>
      ),
    }
  })

  if (observerLoading) {
    return <Loading />
  }

  return (
    <>
      <div>
        <Title level={2}>予約リスト設定</Title>
      </div>
      <div className="flex flex-col gap-8">
        {/* オブザーバー一覧 */}
        <Card shadow className="w-100">
          <div className="flex justify-between items-center mb-4">
            <Title level={5}>オブザーバー管理</Title>
            <Button
              htmlType="button"
              onClick={() => setIsCreateObserverForm(true)}
              type="primary"
            >
              追加する
            </Button>
          </div>
          <div>
            <Table columns={observerColumns} dataSource={observerList} />
          </div>
        </Card>
        {/* オブザーバー追加モーダル */}
        <Modal
          open={isCreateObserverForm}
          title="オブザーバーの追加"
          footer={
            <>
              <Button danger onClick={() => setIsCreateObserverForm(false)}>
                閉じる
              </Button>
            </>
          }
        >
          <ObserverForm
            formType="create"
            popTitle="オブザーバーの追加"
            popDescription="オブザーバーを追加しますか？"
          />
        </Modal>

        {/* オブザーバー編集モーダル */}
        <Modal
          open={isUpdateObserverForm}
          title="オブザーバーの編集"
          footer={
            <>
              <Button danger onClick={() => setIsUpdateObserverForm(false)}>
                閉じる
              </Button>
            </>
          }
        >
          <ObserverForm
            formType="update"
            popTitle="オブザーバー情報の編集"
            popDescription="オブザーバー情報を更新しますか？"
            userInfo={observerInfoById}
          />
        </Modal>

        {/* <Card>
          <Button
            onClick={() => {
              setIsPreview(true)
              eventsRefetch()
            }}
            type="primary"
          >
            プレビュー
          </Button>
        </Card> */}
        {/* 施設表示設定 */}
        <Card shadow className="w-100">
          <Title level={5}>表示施設管理</Title>
          <div className="mb-12">
            <CalendarSettingsTable />
          </div>
          <Button
            onClick={() => {
              setIsPreview(true)
              eventsRefetch()
            }}
            type="primary"
          >
            プレビュー
          </Button>
        </Card>
      </div>

      {/* カレンダープレビュー */}
      <Modal
        width={780}
        open={isPreview}
        title="プレビュー"
        footer={[
          <Button key="ok" onClick={() => setIsPreview(false)}>
            閉じる
          </Button>,
        ]}
      >
        <BookingsCalendar eventSources={events} />
      </Modal>
    </>
  )
}

export default CalendarSettings
